import { FormState } from '../../models';
import { otherMonitorsInfo } from './unknown-monitor-info';
import { dialogActions } from './dialog-actions';
import { basicInfo } from './basic-info';
import { UnknownLocationCardState } from './models'

/**
 * Unknown form configuration
 */
export const unknownFormState = (
    state: UnknownLocationCardState,
    series: string
): FormState => {
    return {
        config: {
            info: {
                id: 'unknonw-location-config',
                title: 'Unknown Location Configuration',
            },
            sections: [
                basicInfo(state),
                otherMonitorsInfo(series, state.permissions),
                dialogActions(state),
            ],
        },
        pristine: true,
        valid: false,
        submitted: false,
    };
};
